module.exports = __webpack_public_path__ + "img/np_nocloud_3248487_000000.5fb0362d.svg";